import React from 'react';
import PropTypes from 'prop-types';
import Select from 'antd/lib/select';

const { Option } = Select;

const DocumentSelect = ({
  selectedValue,
  handeSelect,
  options,
  translations,
  disabled = false,
}) => (
  <Select
    value={selectedValue}
    onChange={handeSelect}
    disabled={disabled}
    style={{ width: '100%', maxWidth: 250 }}
  >
    {options.map(option => <Option key={option}>{translations[option]}</Option>)}
  </Select>
);

DocumentSelect.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  handeSelect: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default DocumentSelect;



// WEBPACK FOOTER //
// ./src/features/documents/components/DocumentSelect.js